import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import { Meta } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-product-lottery',
  templateUrl: './product-lottery.component.html',
  styleUrls: ['./product-lottery.component.css']
})
export class ProductLotteryComponent implements OnInit {

  //constructor(){}
  //commentted and new code added by Digvijay on 17-06-2019
  constructor(private meta: Meta,private titleService: Title, private location: Location) {
    //this.meta.addTag({ name: 'description', content: 'Lottery Inventory Management Software' },true);
    this.meta.addTag({ name: 'description', content: 'We have specialised in lottery software solutions for over 7 years. Lottery automation software offers easy management of inventory, purchase order & reports.' },true);
    this.meta.addTag({ name: 'author', content: 'ShreeMon' },true);
    this.meta.addTag({ name: 'keywords', content: 'Lottery Inventory Management Software,Lottery Management System,lottery tracking software ,lottery software, lottery tracking software, lottery system software, lottery inventory management software, best lottery  software' },true);
    this.titleService.setTitle('Lottery Inventory Management Software Solutions | Shreemon');
  }

  ngOnInit() {
    this.location.replaceState("/Product/Lottery-Inventory-Software");
  }

}
